import React, { useState, useContext } from 'react';
import { withRouter } from "react-router-dom";
import Styled from 'styled-components';
import { ArrowDropDown, ArrowDropUp, AccountCircle } from '@material-ui/icons';
import Collapse from '@material-ui/core/Collapse';
import { ServerUrl, GetCurrentYear } from '../../constants';
import axios from 'axios';
import { AppContext } from '../../context/appContext';

const titleBackgroundColor = `#04AA6D`;

const MenuContainer = Styled.div`
cursor: pointer;
color: #FFFFFF;
display: flex;
justify-content: flex-start;
align-items: center;
padding: 0px 16px;
height: 40px;
background-color: ${props => props.isMouseOver ? titleBackgroundColor : null};
position: relative;
`;

const DropDownContainer = Styled.div`
border-left: 6px solid ${titleBackgroundColor};
border-right: 6px solid ${titleBackgroundColor};
border-bottom: 6px solid ${titleBackgroundColor};
display: flex;
align-items: center;
position: absolute;
top: 40px;
left: 0px;
visibility: ${props => props.isMouseOver ? 'visible' : 'hidden' };
`;

const Menu = Styled.div`
display: flex;
justify-content: center;
flex-direction: column;
cursor: pointer;
color: #FFFFFF;
white-space: nowrap;
padding: 0px 32px;
height: 30px;
&:hover {
  background-color: ${titleBackgroundColor};
}
`;

const DropDownMenu = (props) => {
  const { CurrentUser, QuickSightUrl } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;

  const { collapsible } = props;
  const [titleMouseOver, setTitleMouseOver] = useState(false);
  const [showMenu, setShowMenu ] = useState(false);

  const ExportAll = () => {
    const currentYear = GetCurrentYear() - 2000;
    let current_year = currentYear + '-' + (currentYear + 1);
    let previous_year = (currentYear - 1) + '-' + currentYear;

    alert('Export all')
    axios.get(`${ServerUrl}/annually/all/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','AllIndicators.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  const onMenuClick = () => {
    if (props.menus) {
      setShowMenu((prev) => !prev)
    }
    else if (props.link) 
    {
      if (props.title === "Export All") {
        ExportAll();
        return;
      }
      if (props.title === "Data Lookup") {
        window.open(QuickSightUrl, "_blank");;
        return;
      }
      if (props.link.toString().startsWith('http')) {
        window.open(props.link, '_blank')
      } else {
        props.history.push(props.link)
      }
    }
      
  }

  if (collapsible) {
    return (
      <div>
        <MenuContainer isMouseOver={titleMouseOver} onClick={onMenuClick}
                      onMouseOver={() => setTitleMouseOver(true)} 
                      onMouseOut={() => setTitleMouseOver(false)}>
            {props.showPerson && <AccountCircle fontSize="medium" style={{marginRight: '8px'}} />}
            <span>{props.title}</span>
            {props.menus && !showMenu && <ArrowDropDown fontSize="small" />}
            {props.menus && showMenu && <ArrowDropUp fontSize="small" />}
        </MenuContainer>
        <Collapse in={showMenu}>
          {props.menus && props.menus.map((item, index) => {
            return (
              <Menu key={index} onClick={() => {props.history.push(item.link);setTitleMouseOver(false)}}>
                {item.name}   
              </Menu>
            )
          })}
        </Collapse>
      </div>
    )
  }

  return (
    <MenuContainer isMouseOver={titleMouseOver} 
                   onMouseOver={() => setTitleMouseOver(true)} 
                   onMouseOut={() => setTitleMouseOver(false)}>
      <span>{props.title}</span>
      <ArrowDropDown fontSize="small" />
      <DropDownContainer isMouseOver={titleMouseOver} >
        {props.menus && props.menus.map((item, index) => {
          return (
            <Menu key={index} onClick={() => {props.history.push(item.link);setTitleMouseOver(false)}}>
              {item.name}   
            </Menu>
          )
        })}
      </DropDownContainer>
    </MenuContainer>
  )
}

export default withRouter(DropDownMenu);